import { Typography } from 'antd'
import React from 'react'
import './login-card.css';

const AuthCardComponent = (props) => {
    const { style, title, description, buttonEle, topIcon } = props;
    const { Title, Text } = Typography;
    return (
        <div className='auth-card' style={style}>
            <div className='d-flex flex-column h-100'>
                <div className='mb-4'>
                    <Title className='mb-1' level={3}>
                        {title || ""}
                    </Title>
                    <Text className='description'>
                        {description || ""}
                    </Text>
                    {
                        topIcon && topIcon
                    }
                </div>
                {props.children}
            </div>
            <div>
                {buttonEle || ''}
            </div>
        </div>
    )
}

export default AuthCardComponent